import axiosAuthInstance from "src/utils/getSubdomain"

export const generateExam = (templateId: string) => {
  return axiosAuthInstance.post(`/generate-exam/`, {
    template_id: templateId,
  })
}

export const regenerateExam = (
  question_id: string,
  existing_question_ids?: string[]
) => {
  return axiosAuthInstance.post(`/regenerate-question/`, {
    question_id,
    existing_question_ids,
  })
}

export const createExamPaper = (formData: FormData) => {
  return axiosAuthInstance.post("/exam_papers/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

interface ListExamPaperParams {
  subject?: string
  grade?: string
  status?: string
  complexity?: string
  skip?: number
  limit?: number
}

export const listExamPapers = (params: ListExamPaperParams) => {
  return axiosAuthInstance.get("/exam_papers/", {
    params,
  })
}
export const deleteExamPapers = (exam_id: string) => {
  return axiosAuthInstance.delete(`/exam_papers/${exam_id}`)
}

export const getExamPaperById = (exam_id: string) => {
  return axiosAuthInstance.get(`/exam_papers/${exam_id}`)
}

// Edit exam paper
export const updateExamPaper = (exam_id: string, data: FormData) => {
  return axiosAuthInstance.put(`/exam_papers/${exam_id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}
